import { ISingleIdParams } from '~src/spacesPlatform/utils/actionParams';

import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IProjectActions } from '../types/IProjectActions';

export class GetProjectActionsRequest extends Request<ISingleIdParams, IProjectActions> {
  constructor(id: string) {
    super('getProjectActions', { id: id });
  }
}
